<template>
  <div class="main">
    <videohead title="视频"></videohead>
    <div class="banner">
      <van-swipe class="banner-img" :autoplay="3000" indicator-color="white">
        <van-swipe-item>1</van-swipe-item>
        <van-swipe-item>2</van-swipe-item>
        <van-swipe-item>3</van-swipe-item>
        <van-swipe-item>4</van-swipe-item>
      </van-swipe>
    </div>
    <van-tabs v-model="active" title-active-color="#f69b47" color="#f69b47">
      <van-tab title="推荐">
        <div class="v">
          <div class="v-one">
            <video
              width="100%"
              height="200px"
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
              controls="controls"
            >your browser does not support the video tag</video>
          </div>
          <div class="title">
            <b>第46届世界技能大赛烘焙项目 合影1</b>
            <van-tag plain class="see">4.5k观看</van-tag>
          </div>
        </div>
        <div class="v">
          <div class="v-one">
            <video
              width="100%"
              height="200px"
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1196.MOV"
              controls="controls"
            >your browser does not support the video tag</video>
          </div>
          <div class="title">
            <b>第46届世界技能大赛烘焙项目 合影2</b>
            <van-tag plain class="see">6.6k观看</van-tag>
          </div>
        </div>
        <div class="v">
          <div class="v-one">
            <video
              width="100%"
              height="200px"
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
              controls="controls"
            >your browser does not support the video tag</video>
          </div>
          <div class="title">
            <b>第46届世界技能大赛烘焙项目 合影1</b>
            <van-tag plain class="see">4.5k观看</van-tag>
          </div>
        </div>
        <div class="v">
          <div class="v-one">
            <video
              width="100%"
              height="200px"
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
              controls="controls"
            >your browser does not support the video tag</video>
          </div>
          <div class="title">
            <b>第46届世界技能大赛烘焙项目 合影1</b>
            <van-tag plain class="see">4.5k观看</van-tag>
          </div>
        </div>
        <div class="v">
          <div class="v-one">
            <video
              width="100%"
              height="200px"
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
              controls="controls"
            >your browser does not support the video tag</video>
          </div>
          <div class="title">
            <b>第46届世界技能大赛烘焙项目 合影1</b>
            <van-tag plain class="see">4.5k观看</van-tag>
          </div>
        </div>
      </van-tab>
      <van-tab title="西点"></van-tab>
      <van-tab title="调酒&咖啡">3</van-tab>
      <van-tab title="西餐">4</van-tab>
    </van-tabs>
    <d-player
      id="video"
      ref="player"
      @play="play"
      :logo="logo"
      :lang="lang"
      :video="video"
      :contextmenu="contextmenu"
    ></d-player>
  </div>
</template>

<script>
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";

export default {
  data() {
    return {
      video: {
        quality: [
          {
            name: "240P",
            url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
          },
          {
            name: "360P",
            url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
          },
          {
            name: "720P",
            url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/video/like/MVI_1194.MOV"
          }
        ],
        pic:
          "http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg",
        defaultQuality: 1,
        thumbnails: logoImg,
        type: "hls"
      },
      lang: "zh-cn",
      logo: logoImg,
      autoplay: false,
      player: null,
      contextmenu: [
        {
          text: "博客园",
          link: "http://www.cnblogs.com/maqingyuan/"
        },
        {
          text: "博客园",
          link: "http://www.cnblogs.com/maqingyuan/"
        },
        {
          text: "博客园",
          link: "http://www.cnblogs.com/maqingyuan/"
        }
      ]
    }
  },

  components: {
    videohead: () => import("../../components/head/videohead"),
    "d-player": VueDPlayer
  },
  methods: {
    play() {
      console.log("开始播放");
    }
  }
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 200px;
  padding: 15px;
  margin-top: 50px;
  border-bottom: 1px solid #eee;
}
.banner-img {
  width: 100%;
  height: 170px;
  background: #666;
  border-radius: 5px;
}
.v {
  width: 100%;
  height: 265px;
  padding: 15px;
  border-bottom: 1px solid #eee;
}
.v-one {
  width: 100%;
  height: 200px;
  border-radius: 5px;
}

.title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.see {
  float: right;
  margin-top: 4px;
}
#video {
  width: 100%;
  height: 200px;
}
</style>
